import { SVGProps } from 'react'

const icons = {
	Bed: (props: SVGProps<SVGSVGElement>) => (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 24 24'
			fill='currentColor'
			{...props}
		>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M4.8 12C4.62386 12 4.43064 12.0768 4.2705 12.2548C4.10723 12.4362 4 12.7028 4 13V21C4 21.5523 3.55228 22 3 22C2.44772 22 2 21.5523 2 21V13C2 12.2364 2.27205 11.4856 2.78391 10.9168C3.2989 10.3446 4.02136 10 4.8 10H19.2C19.9786 10 20.7011 10.3446 21.2161 10.9168C21.7279 11.4856 22 12.2364 22 13V21C22 21.5523 21.5523 22 21 22C20.4477 22 20 21.5523 20 21V13C20 12.7028 19.8928 12.4362 19.7295 12.2548C19.5694 12.0768 19.3761 12 19.2 12H4.8Z'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M6.75 6C6.59746 6 6.41929 6.06812 6.26514 6.24429C6.10726 6.42472 6 6.69486 6 7V11C6 11.5523 5.55228 12 5 12C4.44772 12 4 11.5523 4 11V7C4 6.24427 4.26149 5.497 4.75999 4.92728C5.26222 4.3533 5.97429 4 6.75 4H17.25C18.0257 4 18.7378 4.3533 19.24 4.92728C19.7385 5.497 20 6.24427 20 7V11C20 11.5523 19.5523 12 19 12C18.4477 12 18 11.5523 18 11V7C18 6.69486 17.8927 6.42472 17.7349 6.24429C17.5807 6.06812 17.4025 6 17.25 6H6.75Z'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M12 4C12.5523 4 13 4.44772 13 5V11C13 11.5523 12.5523 12 12 12C11.4477 12 11 11.5523 11 11V5C11 4.44772 11.4477 4 12 4Z'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M2 19C2 18.4477 2.44772 18 3 18H21C21.5523 18 22 18.4477 22 19C22 19.5523 21.5523 20 21 20H3C2.44772 20 2 19.5523 2 19Z'
			/>
		</svg>
	),
	Bath: (props: SVGProps<SVGSVGElement>) => (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 24 24'
			fill='currentColor'
			{...props}
		>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M11.2071 3.7929C11.5976 4.18342 11.5976 4.81659 11.2071 5.20711L8.70711 7.70711C8.31658 8.09763 7.68342 8.09763 7.29289 7.70711C6.90237 7.31659 6.90237 6.68342 7.29289 6.2929L9.79289 3.7929C10.1834 3.40237 10.8166 3.40237 11.2071 3.7929Z'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M17 18C17.5523 18 18 18.4477 18 19V21C18 21.5523 17.5523 22 17 22C16.4477 22 16 21.5523 16 21V19C16 18.4477 16.4477 18 17 18Z'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M2 12C2 11.4477 2.44772 11 3 11H21C21.5523 11 22 11.4477 22 12C22 12.5523 21.5523 13 21 13H3C2.44772 13 2 12.5523 2 12Z'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M8 18C8.55228 18 9 18.4477 9 19V21C9 21.5523 8.55228 22 8 22C7.44772 22 7 21.5523 7 21V19C7 18.4477 7.44772 18 8 18Z'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M5.81481 3.20425C6.33973 2.99011 6.91505 2.94259 7.46797 3.07002C8.02024 3.1973 8.51652 3.49113 8.90093 3.90482C8.91579 3.92081 8.93012 3.93729 8.94391 3.95422L9.77553 4.97584C10.1242 5.40415 10.0596 6.03402 9.63131 6.38268C9.20299 6.73134 8.57313 6.66677 8.22447 6.23845L7.41727 5.24684C7.29942 5.12717 7.16037 5.05156 7.01882 5.01893C6.87042 4.98473 6.71573 4.99674 6.57025 5.05609C6.42386 5.1158 6.28609 5.22413 6.18072 5.37856C6.07872 5.52806 6.01397 5.71136 6 5.90794V17.1254C6 17.3787 6.09457 17.609 6.24354 17.7686C6.39034 17.9258 6.57414 18 6.75 18H17.25C17.4259 18 17.6097 17.9258 17.7565 17.7686C17.9054 17.609 18 17.3787 18 17.1254V12.5714C18 12.0191 18.4477 11.5714 19 11.5714C19.5523 11.5714 20 12.0191 20 12.5714V17.1254C20 17.8665 19.7258 18.5898 19.2184 19.1334C18.7088 19.6792 18.0024 20 17.25 20H6.75C5.9976 20 5.29117 19.6792 4.78159 19.1334C4.27418 18.5898 4 17.8665 4 17.1254V5.87804C4 5.86082 4.00044 5.8436 4.00133 5.82641C4.03042 5.26395 4.21108 4.71678 4.52862 4.25137C4.84653 3.78541 5.2908 3.41801 5.81481 3.20425Z'
			/>
		</svg>
	),
	Clock: (props: SVGProps<SVGSVGElement>) => (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 24 24'
			fill='currentColor'
			{...props}
		>
			<path
				fill-rule='evenodd'
				clip-rule='evenodd'
				d='M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12Z'
			/>
			<path
				fill-rule='evenodd'
				clip-rule='evenodd'
				d='M12 6C12.5523 6 13 6.44772 13 7V11.596L16.4008 13.0838C16.9068 13.3052 17.1375 13.8948 16.9162 14.4008C16.6948 14.9068 16.1052 15.1375 15.5992 14.9162L11.5992 13.1662C11.2352 13.0069 11 12.6473 11 12.25V7C11 6.44772 11.4477 6 12 6Z'
			/>
		</svg>
	),
	Tag: (props: SVGProps<SVGSVGElement>) => (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 24 24'
			fill='currentColor'
			{...props}
		>
			<path d='M22 11.2568V4.80078C22 4.05806 21.7049 3.3455 21.1797 2.82031C20.6545 2.29513 19.9419 2 19.1992 2H12.7432L12.4658 2.01367C11.8249 2.07753 11.222 2.36084 10.7627 2.82031L2.92578 10.6582C2.33305 11.2547 2.00002 12.0614 2 12.9023C2 13.7433 2.33303 14.55 2.92578 15.1465L8.85352 21.0742C9.45003 21.667 10.2567 22 11.0977 22C11.9386 22 12.7453 21.667 13.3418 21.0742L21.1797 13.2373C21.6392 12.778 21.9225 12.1751 21.9863 11.5342L22 11.2568ZM20 11.2568C19.9999 11.4689 19.9156 11.6723 19.7656 11.8223L11.9316 19.6562L11.8457 19.7344C11.6354 19.9057 11.3712 20 11.0977 20C10.7861 20 10.4872 19.8771 10.2656 19.6582L4.3418 13.7344C4.1229 13.5128 4 13.2139 4 12.9023C4.00002 12.5908 4.12288 12.2919 4.3418 12.0703L12.1777 4.23438C12.3277 4.08443 12.5311 4.00011 12.7432 4H19.1992C19.4115 4 19.6155 4.08426 19.7656 4.23438C19.9157 4.38449 20 4.58849 20 4.80078V11.2568Z' />
			<path d='M15.4951 9C15.219 9 14.9951 8.77614 14.9951 8.5C14.9951 8.22386 15.219 8 15.4951 8C15.7713 8 15.9951 8.22386 15.9951 8.5C15.9951 8.77614 15.7713 9 15.4951 9Z' />
			<path d='M15.4951 8C15.7713 8 15.9951 8.22386 15.9951 8.5C15.9951 8.77614 15.7713 9 15.4951 9C15.219 9 14.9951 8.77614 14.9951 8.5C14.9951 8.22386 15.219 8 15.4951 8ZM13.9951 8.5C13.9951 9.32843 14.6667 10 15.4951 10C16.3236 10 16.9951 9.32843 16.9951 8.5C16.9951 7.67157 16.3236 7 15.4951 7C14.6667 7 13.9951 7.67157 13.9951 8.5Z' />
		</svg>
	),
	Area: (props: SVGProps<SVGSVGElement>) => (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 24 24'
			fill='currentColor'
			{...props}
		>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M7 4H4L4 7H7V4ZM4 2C2.89543 2 2 2.89543 2 4V7C2 8.10457 2.89543 9 4 9H7C8.10457 9 9 8.10457 9 7V4C9 2.89543 8.10457 2 7 2H4Z'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M7 17H4L4 20H7V17ZM4 15C2.89543 15 2 15.8954 2 17V20C2 21.1046 2.89543 22 4 22H7C8.10457 22 9 21.1046 9 20V17C9 15.8954 8.10457 15 7 15H4Z'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M20 4H17V7H20V4ZM17 2C15.8954 2 15 2.89543 15 4V7C15 8.10457 15.8954 9 17 9H20C21.1046 9 22 8.10457 22 7V4C22 2.89543 21.1046 2 20 2H17Z'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M20 17H17V20H20V17ZM17 15C15.8954 15 15 15.8954 15 17V20C15 21.1046 15.8954 22 17 22H20C21.1046 22 22 21.1046 22 20V17C22 15.8954 21.1046 15 20 15H17Z'
			/>
			<path fillRule='evenodd' clipRule='evenodd' d='M16 6H8V4H16V6Z' />
			<path fillRule='evenodd' clipRule='evenodd' d='M16 20H8V18H16V20Z' />
			<path fillRule='evenodd' clipRule='evenodd' d='M6 8L6 16H4L4 8H6Z' />
			<path fillRule='evenodd' clipRule='evenodd' d='M20 8V16H18V8H20Z' />
		</svg>
	),
	Calendar: (props: SVGProps<SVGSVGElement>) => (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 24 24'
			fill='currentColor'
			{...props}
		>
			<path fillRule='evenodd' clipRule='evenodd' d='M21 12H3V10H21V12Z' />
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M18 6H6C4.89543 6 4 6.89543 4 8V18C4 19.1046 4.89543 20 6 20H18C19.1046 20 20 19.1046 20 18V8C20 6.89543 19.1046 6 18 6ZM6 4C3.79086 4 2 5.79086 2 8V18C2 20.2091 3.79086 22 6 22H18C20.2091 22 22 20.2091 22 18V8C22 5.79086 20.2091 4 18 4H6Z'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M9 8C8.44772 8 8 7.55228 8 7V3C8 2.44772 8.44771 2 9 2C9.55228 2 10 2.44772 10 3V7C10 7.55228 9.55228 8 9 8Z'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M15 8C14.4477 8 14 7.55228 14 7V3C14 2.44772 14.4477 2 15 2C15.5523 2 16 2.44772 16 3V7C16 7.55228 15.5523 8 15 8Z'
			/>
		</svg>
	),
	DollarSign: (props: SVGProps<SVGSVGElement>) => (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 24 24'
			fill='currentColor'
			{...props}
		>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M12 2C12.5523 2 13 2.44772 13 3V21C13 21.5523 12.5523 22 12 22C11.4477 22 11 21.5523 11 21V3C11 2.44772 11.4477 2 12 2Z'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M6.31802 5.31802C7.16193 4.47411 8.30653 4 9.5 4H17C17.5523 4 18 4.44772 18 5C18 5.55228 17.5523 6 17 6H9.5C8.83696 6 8.20107 6.26339 7.73223 6.73223C7.26339 7.20107 7 7.83696 7 8.5C7 9.16304 7.26339 9.79893 7.73223 10.2678C8.20107 10.7366 8.83696 11 9.5 11H14.5C15.6935 11 16.8381 11.4741 17.682 12.318C18.5259 13.1619 19 14.3065 19 15.5C19 16.6935 18.5259 17.8381 17.682 18.682C16.8381 19.5259 15.6935 20 14.5 20H6C5.44772 20 5 19.5523 5 19C5 18.4477 5.44772 18 6 18H14.5C15.163 18 15.7989 17.7366 16.2678 17.2678C16.7366 16.7989 17 16.163 17 15.5C17 14.837 16.7366 14.2011 16.2678 13.7322C15.7989 13.2634 15.163 13 14.5 13H9.5C8.30653 13 7.16193 12.5259 6.31802 11.682C5.47411 10.8381 5 9.69347 5 8.5C5 7.30653 5.47411 6.16193 6.31802 5.31802Z'
			/>
		</svg>
	),
	Sparkle: (props: SVGProps<SVGSVGElement>) => (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 24 24'
			fill='currentColor'
			{...props}
		>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M12 4C12.5523 4 13 4.44772 13 5C13 9.41828 9.41828 13 5 13C4.44772 13 4 12.5523 4 12C4 11.4477 4.44772 11 5 11C8.31371 11 11 8.31371 11 5C11 4.44772 11.4477 4 12 4Z'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M12 20C12.5523 20 13 19.5523 13 19C13 14.5817 9.41828 11 5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13C8.31371 13 11 15.6863 11 19C11 19.5523 11.4477 20 12 20Z'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M12 4C11.4477 4 11 4.44772 11 5C11 9.41828 14.5817 13 19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11C15.6863 11 13 8.31371 13 5C13 4.44772 12.5523 4 12 4Z'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M12 20C11.4477 20 11 19.5523 11 19C11 14.5817 14.5817 11 19 11C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13C15.6863 13 13 15.6863 13 19C13 19.5523 12.5523 20 12 20Z'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M5 2C5.55228 2 6 2.44772 6 3C6 4.65685 4.65685 6 3 6C2.44772 6 2 5.55228 2 5C2 4.44772 2.44772 4 3 4C3.55228 4 4 3.55228 4 3C4 2.44772 4.44772 2 5 2Z'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M5 8C5.55228 8 6 7.55228 6 7C6 5.34315 4.65685 4 3 4C2.44772 4 2 4.44772 2 5C2 5.55228 2.44772 6 3 6C3.55228 6 4 6.44772 4 7C4 7.55228 4.44772 8 5 8Z'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M5 2C4.44772 2 4 2.44772 4 3C4 4.65685 5.34315 6 7 6C7.55228 6 8 5.55228 8 5C8 4.44772 7.55228 4 7 4C6.44772 4 6 3.55228 6 3C6 2.44772 5.55228 2 5 2Z'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M5 8C4.44772 8 4 7.55228 4 7C4 5.34315 5.34315 4 7 4C7.55228 4 8 4.44772 8 5C8 5.55228 7.55228 6 7 6C6.44772 6 6 6.44772 6 7C6 7.55228 5.55228 8 5 8Z'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M19 16C19.5523 16 20 16.4477 20 17C20 18.6569 18.6569 20 17 20C16.4477 20 16 19.5523 16 19C16 18.4477 16.4477 18 17 18C17.5523 18 18 17.5523 18 17C18 16.4477 18.4477 16 19 16Z'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M19 22C19.5523 22 20 21.5523 20 21C20 19.3431 18.6569 18 17 18C16.4477 18 16 18.4477 16 19C16 19.5523 16.4477 20 17 20C17.5523 20 18 20.4477 18 21C18 21.5523 18.4477 22 19 22Z'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M19 16C18.4477 16 18 16.4477 18 17C18 18.6569 19.3431 20 21 20C21.5523 20 22 19.5523 22 19C22 18.4477 21.5523 18 21 18C20.4477 18 20 17.5523 20 17C20 16.4477 19.5523 16 19 16Z'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M19 22C18.4477 22 18 21.5523 18 21C18 19.3431 19.3431 18 21 18C21.5523 18 22 18.4477 22 19C22 19.5523 21.5523 20 21 20C20.4477 20 20 20.4477 20 21C20 21.5523 19.5523 22 19 22Z'
			/>
		</svg>
	),
	FilterHandles: (props: SVGProps<SVGSVGElement>) => (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 24 24'
			fill='currentColor'
			{...props}
		>
			<path d='M14 16C14.5523 16 15 16.4477 15 17C15 17.5523 14.5523 18 14 18H5C4.44772 18 4 17.5523 4 17C4 16.4477 4.44772 16 5 16H14Z' />
			<path d='M19 6C19.5523 6 20 6.44772 20 7C20 7.55228 19.5523 8 19 8H10C9.44772 8 9 7.55228 9 7C9 6.44772 9.44772 6 10 6H19Z' />
			<path d='M19 17C19 15.8954 18.1046 15 17 15C15.8954 15 15 15.8954 15 17C15 18.1046 15.8954 19 17 19C18.1046 19 19 18.1046 19 17ZM21 17C21 19.2091 19.2091 21 17 21C14.7909 21 13 19.2091 13 17C13 14.7909 14.7909 13 17 13C19.2091 13 21 14.7909 21 17Z' />
			<path d='M9 7C9 5.89543 8.10457 5 7 5C5.89543 5 5 5.89543 5 7C5 8.10457 5.89543 9 7 9C8.10457 9 9 8.10457 9 7ZM11 7C11 9.20914 9.20914 11 7 11C4.79086 11 3 9.20914 3 7C3 4.79086 4.79086 3 7 3C9.20914 3 11 4.79086 11 7Z' />
		</svg>
	),
	Tour360: (props: SVGProps<SVGSVGElement>) => (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 24 24'
			fill='currentColor'
			{...props}
		>
			<path d='M20 17C20 17 20.0002 16.9947 19.9971 16.9844C19.9936 16.9732 19.9848 16.9515 19.9648 16.9189C19.9224 16.8498 19.8358 16.7459 19.6738 16.6182C19.3437 16.358 18.8039 16.0792 18.0479 15.8271C16.5462 15.3266 14.4079 15 12 15C9.59213 15 7.45384 15.3266 5.95215 15.8271C5.19607 16.0792 4.65632 16.358 4.32617 16.6182C4.16417 16.7459 4.07758 16.8498 4.03516 16.9189C4.01518 16.9515 4.00637 16.9732 4.00293 16.9844C3.99978 16.9947 4 17 4 17C4 17 3.99978 17.0053 4.00293 17.0156C4.00637 17.0268 4.01518 17.0485 4.03516 17.0811C4.07758 17.1502 4.16417 17.2541 4.32617 17.3818C4.65632 17.642 5.19607 17.9208 5.95215 18.1729C7.45384 18.6734 9.59213 19 12 19H13C13.5523 19 14 19.4477 14 20C14 20.5523 13.5523 21 13 21H12C9.43692 21 7.07489 20.6555 5.31934 20.0703C4.44684 19.7794 3.66849 19.4107 3.08789 18.9531C2.5186 18.5044 2 17.8518 2 17C2 16.1482 2.5186 15.4956 3.08789 15.0469C3.66849 14.5893 4.44684 14.2206 5.31934 13.9297C7.07489 13.3445 9.43692 13 12 13C14.5631 13 16.9251 13.3445 18.6807 13.9297C19.5532 14.2206 20.3315 14.5893 20.9121 15.0469C21.4814 15.4956 22 16.1482 22 17C22 18.0648 21.2024 18.8146 20.4248 19.2891C19.5971 19.794 18.4802 20.188 17.2178 20.4697C16.6788 20.59 16.1448 20.2508 16.0244 19.7119C15.9041 19.1729 16.2432 18.6379 16.7822 18.5176C17.9303 18.2614 18.8133 17.9294 19.3828 17.582C19.6664 17.409 19.8347 17.2546 19.9238 17.1396C19.9664 17.0848 19.9852 17.0461 19.9932 17.0254C19.9969 17.0155 19.9984 17.0091 19.999 17.0059C19.9996 17.0027 20 17 20 17Z' />
			<path d='M9.79297 16.793C10.1835 16.4024 10.8165 16.4024 11.207 16.793L13.707 19.293C14.0976 19.6835 14.0976 20.3165 13.707 20.707L11.207 23.207C10.8165 23.5976 10.1835 23.5976 9.79297 23.207C9.40244 22.8165 9.40244 22.1835 9.79297 21.793L11.5859 20L9.79297 18.207C9.40244 17.8165 9.40244 17.1835 9.79297 16.793Z' />
			<path d='M15.6251 8.53906V5.54906C15.6251 3.15706 16.6001 2.01306 18.6931 2.01306C20.7601 2.01306 21.6051 3.18306 21.6051 5.54906V8.53906C21.6051 10.9441 20.6561 12.1011 18.6281 12.1011C16.5481 12.1011 15.6251 10.9571 15.6251 8.53906ZM17.6011 5.51006V8.57806C17.6011 9.76106 17.7571 10.3591 18.6281 10.3591C19.4471 10.3591 19.6291 9.81306 19.6291 8.57806V5.51006C19.6291 4.30106 19.4471 3.72906 18.6151 3.72906C17.8351 3.72906 17.6011 4.26206 17.6011 5.51006Z' />
			<path d='M15.0311 8.86406C15.0311 10.7751 14.0041 12.1011 11.9501 12.1011C9.9221 12.1011 8.9861 10.7751 8.9861 8.94206C8.9861 7.72006 9.5451 6.51106 10.0001 5.44506L11.2351 2.63706C11.3781 2.28606 11.7161 2.01306 12.1191 2.01306C12.6391 2.01306 13.0681 2.40306 13.0681 2.92306C13.0681 3.05306 13.0161 3.22206 12.9771 3.32606L11.9241 5.78306C12.0151 5.75706 12.3011 5.73106 12.4181 5.73106C14.1081 5.77006 15.0311 6.92706 15.0311 8.86406ZM13.0031 8.83806C13.0031 7.88906 12.7171 7.27806 11.9631 7.27806C11.2091 7.27806 10.9621 7.91506 10.9621 8.85106C10.9621 9.95606 11.3131 10.4241 11.9891 10.4241C12.7171 10.4241 13.0031 9.83906 13.0031 8.83806Z' />
			<path d='M3.988 6.953C3.988 6.511 4.3 6.186 4.69 6.186H4.898C5.834 6.186 6.25 5.614 6.25 4.899C6.25 4.236 5.886 3.794 5.015 3.794C4.456 3.794 4.17 3.989 3.923 3.989C3.429 3.989 3.091 3.729 3.091 3.196C3.091 2.806 3.312 2.572 3.637 2.39C4.131 2.104 4.833 2 5.392 2C7.29 2 8.213 3.131 8.213 4.587C8.213 5.718 7.654 6.394 6.9 6.784C7.81 7.135 8.369 7.954 8.369 9.15C8.369 10.697 7.394 12.101 5.223 12.101C4.703 12.101 3.988 12.049 3.507 11.763C3.208 11.594 3 11.321 3 10.957C3 10.424 3.403 10.151 3.884 10.177C4.17 10.203 4.391 10.333 4.911 10.333C5.951 10.333 6.341 9.865 6.341 9.02C6.341 8.11 5.886 7.72 4.911 7.733H4.69C4.3 7.733 3.988 7.408 3.988 6.953Z' />
		</svg>
	),
	Grid: (props: SVGProps<SVGSVGElement>) => (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 24 24'
			fill='currentColor'
			{...props}
		>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M5 5V9H9V5H5ZM3 4.85714C3 3.83147 3.83147 3 4.85714 3H9.14286C10.1685 3 11 3.83147 11 4.85714V9.14286C11 10.1685 10.1685 11 9.14286 11H4.85714C3.83147 11 3 10.1685 3 9.14286V4.85714Z'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M15 5V9H19V5H15ZM13 4.85714C13 3.83147 13.8315 3 14.8571 3H19.1429C20.1685 3 21 3.83147 21 4.85714V9.14286C21 10.1685 20.1685 11 19.1429 11H14.8571C13.8315 11 13 10.1685 13 9.14286V4.85714Z'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M15 15V19H19V15H15ZM13 14.8571C13 13.8315 13.8315 13 14.8571 13H19.1429C20.1685 13 21 13.8315 21 14.8571V19.1429C21 20.1685 20.1685 21 19.1429 21H14.8571C13.8315 21 13 20.1685 13 19.1429V14.8571Z'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M5 15V19H9V15H5ZM3 14.8571C3 13.8315 3.83147 13 4.85714 13H9.14286C10.1685 13 11 13.8315 11 14.8571V19.1429C11 20.1685 10.1685 21 9.14286 21H4.85714C3.83147 21 3 20.1685 3 19.1429V14.8571Z'
			/>
		</svg>
	),
	Split: (props: SVGProps<SVGSVGElement>) => (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 24 24'
			fill='currentColor'
			{...props}
		>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M19 5H5L5 19H19V5ZM5 3C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3H5Z'
			/>
			<path fillRule='evenodd' clipRule='evenodd' d='M11 20L11 4L13 4L13 20H11Z' />
		</svg>
	),
	Map: (props: SVGProps<SVGSVGElement>) => (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 24 24'
			fill='currentColor'
			{...props}
		>
			<path d='M14.67 21C14.24 21 13.8 20.9 13.42 20.7L9.68 18.78C9.47 18.67 9.21 18.67 9 18.78L5.75 20.45C5.46 20.6 5.13 20.66 4.81 20.66C4.48 20.64 4.16 20.54 3.89 20.37C3.62 20.2 3.39 19.95 3.24 19.67C3.08 19.37 3 19.06 3 18.73V7.09C3 6.74 3.1 6.39 3.28 6.09C3.46 5.79 3.73 5.54 4.04 5.38L8.08 3.3C8.85 2.9 9.81 2.9 10.58 3.3L14.32 5.22C14.53 5.33 14.79 5.33 15 5.22L18.25 3.55C18.54 3.4 18.87 3.33 19.19 3.34C19.52 3.36 19.83 3.46 20.11 3.63C20.38 3.8 20.61 4.04 20.76 4.33C20.92 4.62 21 4.94 20.99 5.26V16.9C20.99 17.25 20.89 17.6 20.71 17.9C20.53 18.2 20.27 18.45 19.96 18.61L15.91 20.69C15.52 20.89 15.09 20.99 14.66 20.99L14.67 21ZM9.33 16.69C9.76 16.69 10.2 16.8 10.58 16.99L14.32 18.91C14.53 19.02 14.79 19.02 15 18.91L19.05 16.83L19 5.39L15.92 6.99C15.15 7.39 14.19 7.39 13.42 6.99L9.68 5.07C9.47 4.96 9.21 4.96 9 5.07L4.95 7.16L5 18.6L8.08 17C8.47 16.8 8.9 16.7 9.33 16.7V16.69Z' />
			<path d='M15 21C14.45 21 14 20.55 14 20V7C14 6.45 14.45 6 15 6C15.55 6 16 6.45 16 7V20C16 20.55 15.55 21 15 21Z' />
			<path d='M9 18C8.45 18 8 17.55 8 17V4C8 3.45 8.45 3 9 3C9.55 3 10 3.45 10 4V17C10 17.55 9.55 18 9 18Z' />
		</svg>
	),
	Plus: (props: SVGProps<SVGSVGElement>) => (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 24 24'
			fill='currentColor'
			{...props}
		>
			<path d='M11 4C11 3.44772 11.4477 3 12 3C12.5523 3 13 3.44772 13 4V20C13 20.5523 12.5523 21 12 21C11.4477 21 11 20.5523 11 20V4Z' />
			<path d='M4 13C3.44772 13 3 12.5523 3 12C3 11.4477 3.44772 11 4 11H20C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13H4Z' />
		</svg>
	),
	Minus: (props: SVGProps<SVGSVGElement>) => (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 24 24'
			fill='currentColor'
			{...props}
		>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M3 12C3 11.4477 3.40294 11 3.9 11H20.1C20.5971 11 21 11.4477 21 12C21 12.5523 20.5971 13 20.1 13H3.9C3.40294 13 3 12.5523 3 12Z'
			/>
		</svg>
	),
	Maximize: (props: SVGProps<SVGSVGElement>) => (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 24 24'
			fill='currentColor'
			{...props}
		>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M6 5C5.73478 5 5.48043 5.10536 5.29289 5.29289C5.10536 5.48043 5 5.73478 5 6V8C5 8.55228 4.55228 9 4 9C3.44772 9 3 8.55228 3 8V6C3 5.20435 3.31607 4.44129 3.87868 3.87868C4.44129 3.31607 5.20435 3 6 3H8C8.55228 3 9 3.44772 9 4C9 4.55228 8.55228 5 8 5H6Z'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M4 15C4.55228 15 5 15.4477 5 16V18C5 18.2652 5.10536 18.5196 5.29289 18.7071C5.48043 18.8946 5.73478 19 6 19H8C8.55228 19 9 19.4477 9 20C9 20.5523 8.55228 21 8 21H6C5.20435 21 4.44129 20.6839 3.87868 20.1213C3.31607 19.5587 3 18.7956 3 18V16C3 15.4477 3.44772 15 4 15Z'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M15 4C15 3.44772 15.4477 3 16 3H18C18.7956 3 19.5587 3.31607 20.1213 3.87868C20.6839 4.44129 21 5.20435 21 6V8C21 8.55228 20.5523 9 20 9C19.4477 9 19 8.55228 19 8V6C19 5.73478 18.8946 5.48043 18.7071 5.29289C18.5196 5.10536 18.2652 5 18 5H16C15.4477 5 15 4.55228 15 4Z'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M20 15C20.5523 15 21 15.4477 21 16V18C21 18.7957 20.6839 19.5587 20.1213 20.1213C19.5587 20.6839 18.7957 21 18 21H16C15.4477 21 15 20.5523 15 20C15 19.4477 15.4477 19 16 19H18C18.2652 19 18.5196 18.8946 18.7071 18.7071C18.8946 18.5196 19 18.2652 19 18V16C19 15.4477 19.4477 15 20 15Z'
			/>
		</svg>
	),
	X: (props: SVGProps<SVGSVGElement>) => (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 24 24'
			fill='currentColor'
			{...props}
		>
			<path d='M17.293 5.29297C17.6835 4.90245 18.3165 4.90245 18.707 5.29297C19.0975 5.68349 19.0975 6.31651 18.707 6.70703L6.70702 18.707C6.31649 19.0976 5.68348 19.0976 5.29295 18.707C4.90243 18.3165 4.90243 17.6835 5.29295 17.293L17.293 5.29297Z' />
			<path d='M5.29295 5.29297C5.68348 4.90245 6.31649 4.90245 6.70702 5.29297L18.707 17.293C19.0975 17.6835 19.0975 18.3165 18.707 18.707C18.3165 19.0976 17.6835 19.0976 17.293 18.707L5.29295 6.70703C4.90243 6.31651 4.90243 5.68349 5.29295 5.29297Z' />
		</svg>
	),
	CaretDown: (props: SVGProps<SVGSVGElement>) => (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 24 24'
			fill='currentColor'
			{...props}
		>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M12.7071 16.7071C12.3166 17.0976 11.6834 17.0976 11.2929 16.7071L5.29289 10.7071C4.90237 10.3166 4.90237 9.68342 5.29289 9.29289C5.68342 8.90237 6.31658 8.90237 6.70711 9.29289L12 14.5858L17.2929 9.29289C17.6834 8.90237 18.3166 8.90237 18.7071 9.29289C19.0976 9.68342 19.0976 10.3166 18.7071 10.7071L12.7071 16.7071Z'
			/>
		</svg>
	),
	CaretUp: (props: SVGProps<SVGSVGElement>) => (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 24 24'
			fill='currentColor'
			{...props}
		>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M11.2929 7.29289C11.6834 6.90237 12.3166 6.90237 12.7071 7.29289L18.7071 13.2929C19.0976 13.6834 19.0976 14.3166 18.7071 14.7071C18.3166 15.0976 17.6834 15.0976 17.2929 14.7071L12 9.41421L6.70711 14.7071C6.31658 15.0976 5.68342 15.0976 5.29289 14.7071C4.90237 14.3166 4.90237 13.6834 5.29289 13.2929L11.2929 7.29289Z'
			/>
		</svg>
	),
	CaretFirst: (props: SVGProps<SVGSVGElement>) => (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 24 24'
			fill='currentColor'
			{...props}
		>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M6 5C6.55228 5 7 5.44772 7 6V18C7 18.5523 6.55228 19 6 19C5.44772 19 5 18.5523 5 18V6C5 5.44772 5.44772 5 6 5Z'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M10.2929 12.7071C9.90237 12.3166 9.90237 11.6834 10.2929 11.2929L16.2929 5.29289C16.6834 4.90237 17.3166 4.90237 17.7071 5.29289C18.0976 5.68342 18.0976 6.31658 17.7071 6.70711L12.4142 12L17.7071 17.2929C18.0976 17.6834 18.0976 18.3166 17.7071 18.7071C17.3166 19.0976 16.6834 19.0976 16.2929 18.7071L10.2929 12.7071Z'
			/>
		</svg>
	),
	CaretLeft: (props: SVGProps<SVGSVGElement>) => (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 24 24'
			fill='currentColor'
			{...props}
		>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M7.29289 12.7071C6.90237 12.3166 6.90237 11.6834 7.29289 11.2929L13.2929 5.29289C13.6834 4.90237 14.3166 4.90237 14.7071 5.29289C15.0976 5.68342 15.0976 6.31658 14.7071 6.70711L9.41421 12L14.7071 17.2929C15.0976 17.6834 15.0976 18.3166 14.7071 18.7071C14.3166 19.0976 13.6834 19.0976 13.2929 18.7071L7.29289 12.7071Z'
			/>
		</svg>
	),
	CaretRight: (props: SVGProps<SVGSVGElement>) => (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 24 24'
			fill='currentColor'
			{...props}
		>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M16.7071 11.2929C17.0976 11.6834 17.0976 12.3166 16.7071 12.7071L10.7071 18.7071C10.3166 19.0976 9.68342 19.0976 9.29289 18.7071C8.90237 18.3166 8.90237 17.6834 9.29289 17.2929L14.5858 12L9.29289 6.70711C8.90237 6.31658 8.90237 5.68342 9.29289 5.29289C9.68342 4.90237 10.3166 4.90237 10.7071 5.29289L16.7071 11.2929Z'
			/>
		</svg>
	),
	CaretLast: (props: SVGProps<SVGSVGElement>) => (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 24 24'
			fill='currentColor'
			{...props}
		>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M18 5C18.5523 5 19 5.44772 19 6V18C19 18.5523 18.5523 19 18 19C17.4477 19 17 18.5523 17 18V6C17 5.44772 17.4477 5 18 5Z'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M13.7071 11.2929C14.0976 11.6834 14.0976 12.3166 13.7071 12.7071L7.70711 18.7071C7.31658 19.0976 6.68342 19.0976 6.29289 18.7071C5.90237 18.3166 5.90237 17.6834 6.29289 17.2929L11.5858 12L6.29289 6.70711C5.90237 6.31658 5.90237 5.68342 6.29289 5.29289C6.68342 4.90237 7.31658 4.90237 7.70711 5.29289L13.7071 11.2929Z'
			/>
		</svg>
	),
	ArrowLeft: (props: SVGProps<SVGSVGElement>) => (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 24 24'
			fill='currentColor'
			{...props}
		>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M11.7526 4.34151C12.1163 4.75715 12.0741 5.38891 11.6585 5.75259L5.66145 11H21C21.5523 11 22 11.4477 22 12C22 12.5523 21.5523 13 21 13H5.66145L11.6585 18.2474C12.0741 18.6111 12.1163 19.2429 11.7526 19.6585C11.3889 20.0742 10.7571 20.1163 10.3415 19.7526L2.3415 12.7526C2.12448 12.5627 2 12.2884 2 12C2 11.7117 2.12448 11.4373 2.3415 11.2474L10.3415 4.24744C10.7571 3.88375 11.3889 3.92587 11.7526 4.34151Z'
			/>
		</svg>
	),
	ArrowRight: (props: SVGProps<SVGSVGElement>) => (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 24 24'
			fill='currentColor'
			{...props}
		>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M12.2474 4.34151C11.8837 4.75715 11.9259 5.38891 12.3415 5.75259L18.3386 11H3C2.44772 11 2 11.4477 2 12C2 12.5523 2.44772 13 3 13H18.3386L12.3415 18.2474C11.9259 18.6111 11.8837 19.2429 12.2474 19.6585C12.6111 20.0742 13.2429 20.1163 13.6585 19.7526L21.6585 12.7526C21.8755 12.5627 22 12.2884 22 12C22 11.7117 21.8755 11.4373 21.6585 11.2474L13.6585 4.24744C13.2429 3.88375 12.6111 3.92587 12.2474 4.34151Z'
			/>
		</svg>
	),
	Share: (props: SVGProps<SVGSVGElement>) => (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 24 24'
			fill='none'
			stroke='currentColor'
			strokeWidth='2'
			strokeLinecap='round'
			strokeLinejoin='round'
			{...props}
		>
			<path d='M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8' />
			<polyline points='16 6 12 2 8 6' />
			<line x1='12' x2='12' y1='2' y2='15' />
		</svg>
	),
	Copy: (props: SVGProps<SVGSVGElement>) => (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 24 24'
			fill='none'
			stroke='currentColor'
			strokeWidth='2'
			strokeLinecap='round'
			strokeLinejoin='round'
			{...props}
		>
			<rect width='14' height='14' x='8' y='8' rx='2' ry='2' />
			<path d='M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2' />
		</svg>
	),
	EyeOpen: (props: SVGProps<SVGSVGElement>) => (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 24 24'
			fill='currentColor'
			{...props}
		>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M12 6C10.3071 6 8.64209 6.55799 7.21575 7.61884C5.79418 8.67615 4.67116 10.1882 4.00273 11.9759C3.99909 11.9911 3.99909 12.0089 4.00273 12.0241C4.67116 13.8118 5.79418 15.3239 7.21575 16.3812C8.64209 17.442 10.3071 18 12 18C13.6929 18 15.3579 17.442 16.7842 16.3812C18.2058 15.3239 19.3288 13.8118 19.9973 12.0241C20.0009 12.0089 20.0009 11.9911 19.9973 11.9759C19.3288 10.1882 18.2058 8.67615 16.7842 7.61884C15.3579 6.55799 13.6929 6 12 6ZM6.02218 6.01404C7.78034 4.7064 9.86095 4 12 4C14.139 4 16.2197 4.7064 17.9778 6.01404C19.7344 7.32049 21.0876 9.16552 21.8813 11.304C21.8851 11.3143 21.8887 11.3247 21.8922 11.3351C22.0359 11.7653 22.0359 12.2347 21.8922 12.6649C21.8887 12.6753 21.8851 12.6857 21.8813 12.696C21.0876 14.8345 19.7344 16.6795 17.9778 17.986C16.2197 19.2936 14.139 20 12 20C9.86095 20 7.78034 19.2936 6.02218 17.986C4.26562 16.6795 2.91239 14.8345 2.11873 12.696C2.11491 12.6857 2.11125 12.6753 2.10777 12.6649C1.96408 12.2347 1.96408 11.7653 2.10777 11.3351C2.11125 11.3247 2.11491 11.3143 2.11873 11.304C2.91239 9.16552 4.26562 7.32049 6.02218 6.01404Z'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10ZM8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12Z'
			/>
		</svg>
	),
	Check: (props: SVGProps<SVGSVGElement>) => (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 24 24'
			fill='currentColor'
			{...props}
		>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M21.5899 3.19244C22.0358 3.51821 22.1333 4.14383 21.8075 4.58981L10.12 20.5898C9.94444 20.8302 9.67092 20.9798 9.37382 20.9981C9.07673 21.0163 8.78695 20.9013 8.58327 20.6842L2.27077 13.9569C1.89286 13.5542 1.91299 12.9214 2.31573 12.5434C2.71848 12.1655 3.35132 12.1857 3.72923 12.5884L9.21643 18.4361L20.1925 3.41009C20.5183 2.96411 21.1439 2.86667 21.5899 3.19244Z'
			/>
		</svg>
	),
	ExternalLink: (props: SVGProps<SVGSVGElement>) => (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 24 24'
			fill='none'
			stroke='currentColor'
			strokeWidth='2'
			strokeLinecap='round'
			strokeLinejoin='round'
			{...props}
		>
			<path d='M15 3h6v6' />
			<path d='M10 14 21 3' />
			<path d='M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6' />
		</svg>
	),
	Mail: (props: SVGProps<SVGSVGElement>) => (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 24 24'
			fill='none'
			stroke='currentColor'
			strokeWidth='2'
			strokeLinecap='round'
			strokeLinejoin='round'
			{...props}
		>
			<rect width='20' height='16' x='2' y='4' rx='2' />
			<path d='m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7' />
		</svg>
	),
	Table: (props: SVGProps<SVGSVGElement>) => (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 24 24'
			fill='currentColor'
			{...props}
		>
			<path d='M18.083 19V11.917H5.91699V19C5.91699 19.5063 5.50626 19.917 5 19.917C4.49374 19.917 4.08301 19.5063 4.08301 19V5.91699H3C2.49374 5.91699 2.08301 5.50626 2.08301 5C2.08301 4.49374 2.49374 4.08301 3 4.08301H21L21.0938 4.08789C21.556 4.13484 21.917 4.52538 21.917 5C21.917 5.47462 21.556 5.86516 21.0938 5.91211L21 5.91699H19.917V19C19.917 19.5063 19.5063 19.917 19 19.917C18.4937 19.917 18.083 19.5063 18.083 19ZM5.91699 10.083H18.083V5.91699H5.91699V10.083Z' />
		</svg>
	),
	Calculator: (props: SVGProps<SVGSVGElement>) => (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 24 24'
			fill='currentColor'
			{...props}
		>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M18 4H6V20H18V4ZM6 2C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V4C20 2.89543 19.1046 2 18 2H6Z'
			/>
			<path fillRule='evenodd' clipRule='evenodd' d='M18 10H6V8H18V10Z' />
			<path fillRule='evenodd' clipRule='evenodd' d='M18 14H6V12H18V14Z' />
			<path fillRule='evenodd' clipRule='evenodd' d='M15 18H6V16H15V18Z' />
			<path fillRule='evenodd' clipRule='evenodd' d='M16 9L16 21H14L14 9H16Z' />
			<path fillRule='evenodd' clipRule='evenodd' d='M11 9L11 21H9L9 9H11Z' />
		</svg>
	),
	Sun: (props: SVGProps<SVGSVGElement>) => (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 24 24'
			fill='currentColor'
			{...props}
		>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9ZM7 12C7 9.23858 9.23858 7 12 7C14.7614 7 17 9.23858 17 12C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12Z'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M12 1C12.5523 1 13 1.44772 13 2V4C13 4.55228 12.5523 5 12 5C11.4477 5 11 4.55228 11 4V2C11 1.44772 11.4477 1 12 1Z'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M12 19C12.5523 19 13 19.4477 13 20V22C13 22.5523 12.5523 23 12 23C11.4477 23 11 22.5523 11 22V20C11 19.4477 11.4477 19 12 19Z'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M4.22289 4.22295C4.61341 3.83242 5.24657 3.83242 5.6371 4.22295L7.0471 5.63295C7.43762 6.02347 7.43762 6.65664 7.0471 7.04716C6.65658 7.43769 6.02341 7.43769 5.63289 7.04716L4.22289 5.63716C3.83236 5.24664 3.83236 4.61347 4.22289 4.22295Z'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M16.9529 16.9529C17.3434 16.5624 17.9766 16.5624 18.3671 16.9529L19.7771 18.3629C20.1676 18.7535 20.1676 19.3866 19.7771 19.7771C19.3866 20.1677 18.7534 20.1677 18.3629 19.7771L16.9529 18.3671C16.5624 17.9766 16.5624 17.3435 16.9529 16.9529Z'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M1 12C1 11.4477 1.44772 11 2 11H4C4.55228 11 5 11.4477 5 12C5 12.5523 4.55228 13 4 13H2C1.44772 13 1 12.5523 1 12Z'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M19 12C19 11.4477 19.4477 11 20 11H22C22.5523 11 23 11.4477 23 12C23 12.5523 22.5523 13 22 13H20C19.4477 13 19 12.5523 19 12Z'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M7.0471 16.9529C7.43762 17.3435 7.43762 17.9766 7.0471 18.3671L5.6371 19.7771C5.24657 20.1677 4.61341 20.1677 4.22289 19.7771C3.83236 19.3866 3.83236 18.7535 4.22289 18.3629L5.63289 16.9529C6.02341 16.5624 6.65658 16.5624 7.0471 16.9529Z'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M19.7771 4.22295C20.1676 4.61347 20.1676 5.24664 19.7771 5.63716L18.3671 7.04716C17.9766 7.43769 17.3434 7.43769 16.9529 7.04716C16.5624 6.65664 16.5624 6.02347 16.9529 5.63295L18.3629 4.22295C18.7534 3.83242 19.3866 3.83242 19.7771 4.22295Z'
			/>
		</svg>
	),
	Moon: (props: SVGProps<SVGSVGElement>) => (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 24 24'
			fill='currentColor'
			{...props}
		>
			<path d='M11.5811 2.01327C12.1854 2.02916 12.6375 2.40751 12.8477 2.84726C13.0629 3.29767 13.0621 3.86902 12.7618 4.34823L12.7608 4.34726C12.1619 5.3059 11.9063 6.43996 12.0342 7.56308C12.1622 8.68637 12.6674 9.73337 13.4668 10.5328C14.2663 11.3321 15.3133 11.8365 16.4366 11.9644C17.5599 12.0923 18.6937 11.8361 19.6524 11.2369L19.835 11.1383C20.2703 10.9406 20.7565 10.9618 21.1514 11.15C21.6219 11.3743 22.0196 11.8752 21.9835 12.5406C21.8792 14.4694 21.2183 16.3269 20.0811 17.8883C18.9438 19.4497 17.3783 20.6485 15.5743 21.3394C13.7703 22.0303 11.8045 22.1841 9.91509 21.7818C8.02573 21.3795 6.2938 20.4377 4.92779 19.0719C3.56173 17.7059 2.62036 15.974 2.21783 14.0846C1.81531 12.1951 1.96851 10.2295 2.65923 8.42538C3.34999 6.62124 4.54894 5.05605 6.1104 3.91854C7.67185 2.78108 9.52906 2.11956 11.4581 2.01522L11.5811 2.01327ZM10.6211 4.12069C9.42062 4.33047 8.27898 4.81223 7.28716 5.53476C6.03822 6.44468 5.07997 7.69714 4.5274 9.14022C3.97481 10.5835 3.8519 12.156 4.17388 13.6676C4.4959 15.1791 5.24897 16.565 6.34185 17.6578C7.43473 18.7505 8.8205 19.5039 10.3321 19.8258C11.8437 20.1476 13.4162 20.024 14.8594 19.4713C16.3026 18.9185 17.5551 17.9598 18.4649 16.7105C19.1871 15.7189 19.6673 14.5777 19.877 13.3775C18.7336 13.8928 17.4676 14.095 16.21 13.9517C14.6373 13.7726 13.1711 13.0662 12.0518 11.9469C10.9326 10.8276 10.226 9.36134 10.0469 7.78866C9.90376 6.53084 10.1056 5.26426 10.6211 4.12069Z' />
		</svg>
	),
	Link: (props: SVGProps<SVGSVGElement>) => (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 24 24'
			fill='currentColor'
			{...props}
		>
			<path d='M2 12C2 10.4087 2.63259 8.88303 3.75781 7.75781C4.88303 6.63259 6.4087 6 8 6H9C9.55228 6 10 6.44772 10 7C10 7.55228 9.55228 8 9 8H8C6.93913 8 5.92202 8.42173 5.17188 9.17188C4.42173 9.92202 4 10.9391 4 12C4 13.0609 4.42173 14.078 5.17188 14.8281C5.92202 15.5783 6.93913 16 8 16H9C9.55228 16 10 16.4477 10 17C10 17.5523 9.55228 18 9 18H8C6.4087 18 4.88303 17.3674 3.75781 16.2422C2.63259 15.117 2 13.5913 2 12Z' />
			<path d='M20 12C20 10.9391 19.5783 9.92202 18.8281 9.17188C18.1248 8.46859 17.1869 8.0539 16.1982 8.00488L16 8H15C14.4477 8 14 7.55228 14 7C14 6.44772 14.4477 6 15 6H16C17.5913 6 19.117 6.63259 20.2422 7.75781C21.3674 8.88303 22 10.4087 22 12C22 13.5913 21.3674 15.117 20.2422 16.2422C19.1874 17.297 17.7807 17.9185 16.2979 17.9922L16 18H15C14.4477 18 14 17.5523 14 17C14 16.4477 14.4477 16 15 16H16C17.0609 16 18.078 15.5783 18.8281 14.8281C19.5783 14.078 20 13.0609 20 12Z' />
			<path d='M16 11C16.5523 11 17 11.4477 17 12C17 12.5523 16.5523 13 16 13H8C7.44772 13 7 12.5523 7 12C7 11.4477 7.44772 11 8 11H16Z' />
		</svg>
	),
	MessageCircle: (props: SVGProps<SVGSVGElement>) => (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 24 24'
			fill='none'
			stroke='currentColor'
			strokeWidth='2'
			strokeLinecap='round'
			strokeLinejoin='round'
			{...props}
		>
			<path d='M7.9 20A9 9 0 1 0 4 16.1L2 22z' />
		</svg>
	),
	Lock: (props: SVGProps<SVGSVGElement>) => (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 24 24'
			fill='currentColor'
			{...props}
		>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M4 11C4 9.34315 5.34315 8 7 8H17C18.6569 8 20 9.34315 20 11V19C20 20.6569 18.6569 22 17 22H7C5.34315 22 4 20.6569 4 19V11ZM7 10C6.44772 10 6 10.4477 6 11V19C6 19.5523 6.44772 20 7 20H17C17.5523 20 18 19.5523 18 19V11C18 10.4477 17.5523 10 17 10H7Z'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M12 4C10.3431 4 9 5.34315 9 7V9H7V7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7V9H15V7C15 5.34315 13.6569 4 12 4Z'
			/>
			<path d='M10 15C10 13.8954 10.8954 13 12 13C13.1046 13 14 13.8954 14 15C14 16.1046 13.1046 17 12 17C10.8954 17 10 16.1046 10 15Z' />
		</svg>
	)
} as const

export type IconName = keyof typeof icons

interface IconProps extends SVGProps<SVGSVGElement> {
	name: IconName
	size?: number
}

export function Icon ({ name, size = 24, className = '', ...props }: IconProps) {
	const SvgIcon = icons[name]
	return (
		<SvgIcon
			width={size}
			height={size}
			aria-hidden='true'
			className={`spaces-icon ${className}`}
			{...props}
		/>
	)
}
